import get from 'get-value';
import {
    COURTESY_CARS_PRICING_FETCH_PENDING,
    COURTESY_CARS_PRICING_SAVE_PENDING,
    COURTESY_CARS_PRICING_SELECT_GROUP,
} from '../../actions/admin/actionAdminCourtesyCarsPricing';
import {sparePartsWebsocketCommands} from '../../constants/sparePartsWebsocketCommands';

export const adminCourtesyCarsPricing = (state = {
    isLoading: false,
    courtesyCarsPricing: {},
    selectedCountryGroup: ''
}, action) => {
    switch (action.type) {
        case COURTESY_CARS_PRICING_SELECT_GROUP: {
            return Object.assign({}, state, {selectedCountryGroup: action.payload});
        }
        case COURTESY_CARS_PRICING_FETCH_PENDING: {
            return Object.assign({}, state, {isLoading: true, courtesyCarsPricing: {}});
        }
        case COURTESY_CARS_PRICING_SAVE_PENDING: {
            return Object.assign({}, state, {isLoading: true, courtesyCarsPricing: {}});
        }
        case sparePartsWebsocketCommands.SPARE_PARTS_COURTESY_CARS_PRICING_SEND: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                isLoading: false,
                courtesyCarsPricing: get(action, 'payload.courtesyCarsPricing', {default: {}}),
                correlationId
            });
        }
        case sparePartsWebsocketCommands.SPARE_PARTS_COURTESY_CARS_PRICING_ERROR:
        case sparePartsWebsocketCommands.SPARE_PARTS_COURTESY_CARS_PRICING_SEND_ERROR: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {isLoading: false, courtesyCarsPricing: {}, correlationId});
        }
        default: {
            return state;
        }
    }
};
